<template>
  <div :class="`form-group ${error ? 'has-error' : ''}`">
    <label v-show="label" class="control-label">
      {{ label }}
      <span v-if="requiredMark" class="text-danger">*</span>
    </label>
    <div class="input-group">
      <span class="input-group-addon" v-if="symbol">&nbsp;{{ symbol }}&nbsp;</span>
      <i class="input-group-addon" v-if="icon">
        <i class="fa-duotone" :class="icon"></i>
      </i>

      <input
        class="form-control"
        :type="type || 'text'"
        :id="id"
        :name="name"
        :value="value"
        v-bind="$attrs"
        @blur="$emit('blur', $event.target.value)"
        @input="$emit('input', $event.target.value)"
        @change="$emit('change', $event.target.value)"
      />
    </div>
    <small class="text-danger" v-if="error" v-html="error"></small>
    <span class="help-block" v-if="help" v-html="help"></span>
    <slot name="link"></slot>
  </div>
</template>

<script>
export default {
  props: [
    'value',
    'error',
    'label',
    'help',
    'id',
    'type',
    'name',
    'requiredMark',
    'symbol',
    'icon'
  ],
  emits: ['update:modelValue']
}
</script>

<style scoped>
.input-group {
  margin-bottom: 0;
}
</style>